<template>
  <div class="life-recad__about">
    <div class="row row-1">
      <div class="img-and-text">
        <div class="text-group">
          <h3 class="text-accent">LIFE RECAD</h3>
          <h1>{{ $t("life-recad-1") }}</h1>
          <h2>{{ $t("life-recad-2") }}</h2>
          <h2>{{ $t("life-recad-2-1") }} <br> {{ $t("life-recad-2-2") }}</h2>
          <p>{{ $t("life-recad-3") }}</p>
        </div>
      </div>
      <img class="row-img" src="../../assets/img/life_recad/about/1.jpg" />
      <div class="right"></div>
    </div>
    <div class="row row-2">
      <img class="row-img" src="../../assets/img/life_recad/about/2.jpg" />
      <div class="text-group">
        <h2>{{ $t("life-recad-4") }}</h2>
        <ul>
          <li>{{ $t("life-recad-5") }}</li>
          <li>{{ $t("life-recad-6") }}</li>
          <li>{{ $t("life-recad-7") }}</li>
          <li>{{ $t("life-recad-8") }}</li>
        </ul>
      </div>
    </div>
    <div class="row row-3">
      <div class="text-group">
        <h2>{{ $t("life-recad-9") }}</h2>
        <ul>
          <li>{{ $t("life-recad-10") }}</li>
          <li>{{ $t("life-recad-11") }}</li>
          <li>{{ $t("life-recad-12") }}</li>
          <li>{{ $t("life-recad-13") }}</li>
          <li>{{ $t("life-recad-14") }}</li>
          <li>{{ $t("life-recad-15") }}</li>
        </ul>
      </div>
      <img class="row-img" src="../../assets/img/life_recad/about/3.jpg" />
    </div>
    <div class="row row-4">
      <div class="text-group">
        <h3 class="text-accent">{{ $t("life-recad-16") }}</h3>
        <h1>{{ $t("life-recad-17") }}</h1>
      </div>
    </div>
    <div class="timeline">
      <img
        v-if="$i18n.locale === 'bg'"
        src="../../assets/img/life_recad/about/timeline_bg_animated.svg"
      />
      <img
        v-if="$i18n.locale === 'en'"
        src="../../assets/img/life_recad/about/timeline_en_animated.svg"
      />
    </div>
    <!-- <Apply/> -->
  </div>
</template>

<script>
// import Apply from "./shared/Apply";
export default {
  components: {
    // Apply
  },
};
</script>

<style lang="scss" scoped>
.life-recad__about {
  position: relative;
  .row {
    z-index: 1;
    position: relative;
  }
  .row-1 {
    align-items: stretch;
    padding-bottom: 0;
    .img-and-text {
      padding-bottom: $sidesPadding / 2;
    }
    .right {
      @extend %flex-center;
      align-items: flex-end;
      background-image: url("../../assets/img/life_recad/about/1.jpg");
      background-size: cover;
      background-position: center;
      flex-direction: column;
      margin-left: 3%;
      margin-top: $sidesPadding;
      width: 47%;
    }
    .row-img {
      display: none;
    }
  }
  .row-2,
  .row-3 {
    align-items: center;
    margin-top: -$sidesPadding / 4;
    img,
    .text-group {
      width: 45%;
    }
    img {
      display: block;
      height: auto;
      margin-right: 5%;
    }
    .text-group {
      padding-right: $sidesPadding;
      width: 50%;
    }
  }
  .row-3 {
    img {
      margin-right: 0;
      margin-left: 5%;
    }
    .text-group {
      padding-left: $sidesPadding;
      padding-right: 0;
    }
  }
  .row-4 {
    padding: 2rem $sidesPadding;
  }
  .timeline {
    background-color: $mainColor;
    display: flex;
    padding: $sidesPadding;

    img {
      width: 100%;
    }
  }
}
@media screen and (max-width: 1600px) {
  .life-recad__about {
    .row-1 {
      .img-and-text {
        padding-bottom: $sidesPadding1600 / 2;
      }
      .right {
        margin-top: $sidesPadding1600;
      }
    }
    .row-2,
    .row-3 {
      margin-top: -$sidesPadding1600 / 4;
    }
    .row-2 {
      .text-group {
        padding-right: $sidesPadding1600;
      }
    }
    .row-3 {
      .text-group {
        padding-left: $sidesPadding1600;
      }
    }

    .row-4 {
      padding: 2rem $sidesPadding1600;
    }
    .timeline {
      padding: $sidesPadding1600;
    }
  }
}
@media screen and (max-width: 1280px) {
  .life-recad__about {
    .row-2 {
      .text-group {
        padding: 50px 0;
        padding-right: $sidesPadding1600;
      }
    }

    .row-1,
    .row-3 {
      .text-group {
        padding-left: $sidesPadding1280;
      }
    }
    .row-4 {
      padding: 2rem $sidesPadding1280;
    }
    .timeline {
      padding: $sidesPadding1280;
    }
  }
}
@media screen and (max-width: 1000px) {
  .life-recad__about {
    .row-1 {
      align-items: center;
      .img-and-text {
        img {
          display: none;
        }
        padding-bottom: 0;
        .text-group {
          margin: 0;
          padding: $sidesPadding1280;
        }
      }
      .right {
        display: none;
      }
      .row-img {
        display: block;
        height: auto;
        width: 50%;
      }
    }
    .row-2,
    .row-3 {
      margin-top: 0;
    }
    .row-2 {
      .text-group {
        padding: 50px 0;
        padding-right: $sidesPadding1280;
      }
    }
    .row-3 {
      .text-group {
        padding: $sidesPadding1280;
      }
      img {
        margin: 0;
        width: 50%;
      }
    }


    .timeline {
      overflow-x: scroll;
      img {
        height: 40vh;
        width: auto;
      }
    }
  }
}
@media screen and (max-width: 800px) {
  .life-recad__about {
    .row-1,
    .row-2,
    .row-3 {
      padding: 0;
      flex-direction: column;
      .text-group {
        width: 100%;
        padding: $sidesPadding1280;
      }
      .row-img,
      .img-and-text {
        margin: 0;
        width: 100%;
      }
      .img-and-text .text-group p:last-of-type {
        margin-bottom: 0;
      }
    }
    .row-2 {
      flex-direction: column-reverse;
    }
  }
}
@media screen and (max-width: 600px) {
  .life-recad__about {
    .row-1,
    .row-2,
    .row-3 {
      .text-group,
      .img-and-text .text-group {
        padding: $sidesPadding600;
      }
    }
  }
}
</style>
